import * as babylon from "@babylonjs/core";

export function materialForColor(
  name: string,
  color: string,
  scene: babylon.Scene,
) {
  const material = new babylon.StandardMaterial(name, scene);
  recolorMaterial(material, color);
  return material;
}

export function recolorMaterial(
  material: babylon.StandardMaterial,
  color: string,
) {
  const color4 = babylon.Color4.FromHexString(color);
  material.alpha = color4.a;
  const color3 = new babylon.Color3(color4.r, color4.g, color4.b);
  material.ambientColor = color3;
  material.diffuseColor = color3;
  material.specularColor = new babylon.Color3(0.9, 0.9, 0.9);
}
